<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">
                    Cuentas bancarias
                </li>
                <li class="breadcrumb-item active li-actualizar-datos" aria-current="page" title="Actualizar datos" v-if="general.otros.app_modo=='online'" @click=obtener_recursos>
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                </li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body" style="display:flex; flex-wrap: wrap;">
                            <div style="width: 100%; display:flex; justify-content:space-evenly;">
                                <button type="button" class="boton-3d-success" @click=boton_modal_registro>
                                    <i class='fa fa-plus' aria-hidden='true'></i>
                                    Nueva cuenta
                                </button>
                                <button type="button" class="boton-3d-success" @click=boton_modal_registro_bancos>                                    
                                    Bancos
                                </button>
                            </div>       
                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>     
                            <div id="contenedor-tabla-registros" style="width: 100%;">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <!-- inicio modal registro -->
        <div class="modal fade bd-example-modal-lg" id="modal-registro">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        
                        <h5 v-if="datos.registro.id===''">
                            Crear Cuenta bancaria
                        </h5>
                        <h5 v-else>Editar Cuenta bancaria</h5>

                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">

                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Banco:</label>                                    
                                    <select class="form-control input-3d" v-model=datos.registro.bancos_id>
                                        <option value="" disabled>Seleccione</option>                                        
                                        <!-- <option value="bbva">BBVA</option>
                                        <option value="hsbc">HSBC</option>
                                        <option value="citibanamex">CITIBANAMEX</option>
                                        <option value="bancoppel">BANCOPPEL</option> -->
                                        <option v-for='(b,b_index) in datos.bancos.todos' :key=b_index :value=b.id>
                                            {{ b.nombre }}
                                        </option>
                                    </select>
                                </div> 
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Cuenta:</label> 
                                    <input type="text" maxlength="80" class="form-control input-3d" v-model=datos.registro.cuenta>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Clabe interbancaria:</label> 
                                    <input type="text" maxlength="20" class="form-control input-3d" v-model=datos.registro.clabe_interbancaria>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Titular:</label> 
                                    <input type="text" maxlength="100" class="form-control input-3d" v-model=datos.registro.titular>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Numero tarjeta:</label> 
                                    <input type="text" maxlength="100" class="form-control input-3d" v-model=datos.registro.numero_tarjeta>
                                </div>
                                
                                <!--<div class="form-group col-md-12" style="height:280px; overflow:scroll;" v-if="datos.registro_pagos.todos.length>0">
                                    <label for="inputEmail4">Historial de movimientos</label>
                                    <table class="table table-hover">
                                        <thead>                                            
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Fecha</th>
                                                <th scope="col">Saldo antes de pago</th>
                                                <th scope="col">Pago</th>
                                                <th scope="col">Saldo despues de pago</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for='(item,index) in datos.registro_pagos.todos' :key=index>
                                                <th scope="row">{{index+1}}</th> 
                                                <td>{{item.fecha_creacion}}</td>
                                                <td>
                                                    {{ formato_moneda(item.saldo_antes_efectuar) }}
                                                </td>
                                                <td>{{ formato_moneda(item.abono) }}</td>
                                                <td>
                                                    {{ formato_moneda(item.saldo_despues_efectuar) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>-->

                                
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer">
                        
                        <button type="button" class="boton-3d-success" @click=enviar_datos>
                            Guardar
                        </button>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">
                            Cerrar
                        </button>

                    </div>

                </div>
            </div>
        </div>
        <!---fin modal registro---->

        <!-- inicio modal_movimientos -->
        <div class="modal fade bd-example-modal-lg" id="modal_movimientos"  data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl" style="width:90%;">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        
                        <h5>Registra los movimientos de tu cuenta </h5>

                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">
                                
                                <div class="form-group col-md-2 col-6">
                                    <!--<div id="contenedor_img_bancos">
                                        <img v-if="datos.registro.banco=='bancoppel'" src="@/lobato/general/img/bancoppel.png">
                                        <img v-if="datos.registro.banco=='citibanamex'" src="@/lobato/general/img/citibanamex.jpg">
                                        <img v-if="datos.registro.banco=='bbva'" src="@/lobato/general/img/bbva.jpg">
                                        <img v-if="datos.registro.banco=='hsbc'" src="@/lobato/general/img/hsbc.jpeg">
                                    </div>-->
                                    <label for="inputEmail4">Banco:</label>     
                                    <p style="font-size:1.3em;">{{ datos.banco_nombre }}</p>
                                    
                                </div>
                                <div class="form-group col-md-3 col-6">
                                    <label for="inputEmail4">Cuenta:</label>     
                                    <p style="font-size:1.3em;">{{ datos.registro.cuenta }}</p>
                                </div> 
                                <div class="form-group col-md-4 col-6">
                                    <label for="inputEmail4">Titular:</label> 
                                    <p style="font-size:1.3em;">{{ datos.registro.titular }}</p>
                                </div> 
                                <div class="form-group col-md-3 col-6">
                                    <label for="inputEmail4">Dinero disponible:</label> 
                                    <p v-if="!datos.registro_cargando" style="font-size:1.5em;">
                                        {{ general_formato_moneda(datos.ultimo_total) }}
                                    </p>
                                </div> 

                                <div class="form-group col-md-6 col-12">

                                    <div class="form-row">

                                        <div class="form-group col-md-4 col-12">
                                            <label for="inputEmail4">Fecha:</label> 
                                            <input type="date" class="form-control input-3d" v-model=datos.registro_movimientos.fecha_creacion>
                                        </div> 
                                        <div class="form-group col-md-4 col-12">
                                            <label for="inputEmail4">Tipo de movimiento:</label>                                    
                                            <select class="form-control input-3d" id="input_operacion" v-model=datos.registro_movimientos.operacion @change=operacion_seleccionado>
                                                <option value="" disabled>Seleccione</option>                                        
                                                <option value="sumar">Entrada</option>
                                                <option value="restar">Salida</option>
                                            </select>
                                        </div> 
                                        <div class="form-group col-md-4 col-12">
                                            <label for="inputEmail4">Cantidad:</label> 
                                            <input type="number" id="input_cantidad" class="form-control input-3d" v-model=datos.registro_movimientos.cantidad @keydown=cantidad_ingresado($event)>
                                        </div>            

                                        <div class="form-group col-md-12 col-12">
                                            <label for="inputEmail4">Descripcion:</label> 
                                            <textarea class="form-control input-3d" id="input_descripcion" rows="3" v-model=datos.registro_movimientos.descripcion></textarea>
                                        </div>
                                    </div>

                                </div>   

                                <div class="form-group col-md-6 col-12">
                                    
                                    <label for="inputEmail4">Historial de movimientos</label>
                                    <div id="contenedor_tabla_ultimos_movimientos">
                                        
                                        <table v-if="datos.ultimos_movimientos.length>0" class="table table-hover">
                                            <!-- <thead>                                            
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Fecha</th>
                                                    <th scope="col">Cantidad</th>
                                                    <th scope="col">Pago</th>
                                                    <th scope="col">Saldo despues de pago</th>
                                                </tr>
                                            </thead> -->
                                            <tbody>
                                                <tr v-for='(m,index) in datos.ultimos_movimientos' :key=index>
                                                    <th scope="row">
                                                        <p class="fecha_creacion">{{ m.fecha_creacion }}</p>
                                                        <p class="hora_creacion">{{ m.hora_creacion }}</p>
                                                        <p class="descripcion">{{ m.descripcion }}</p>
                                                    </th> 
                                                    <td style="width:50%;">
                                                        <div class="contenedor-cantidad-remover">

                                                            <!-- <button v-if="m.estado=='activo' && [null,''].includes(m.ventas_transferencias_id) && [null,''].includes(m.compras_transferencias_id)" class='boton-3d-danger' title="revertir movimiento" @click=remover_movimiento(m.clave_visualizar)>                                                            
                                                                <i class='fa fa-times' aria-hidden='true'></i>
                                                            </button> -->
                                                            <button v-if="m.mostrar_boton_remover" class='boton-3d-danger' title="revertir movimiento" @click=remover_movimiento(m.clave_visualizar)>                                                            
                                                                <i class='fa fa-times' aria-hidden='true'></i>
                                                            </button>

                                                            <!-- <p v-if="m.estado=='activo' && m.id_revertido!==null">
                                                                ( De una Reversión )
                                                            </p> -->

                                                            <p v-if="m.estado=='revertido'">
                                                                ( Movimiento Revertido )
                                                            </p>

                                                            <p class="cantidad" :class="{cantidad_restar:m.operacion=='restar'}">
                                                                <template v-if="m.operacion=='sumar'">
                                                                    +
                                                                </template>
                                                                <template v-else-if="m.operacion=='restar'">
                                                                    -
                                                                </template>
                                                                {{ general_formato_moneda(m.cantidad) }} 
                                                            </p>
                                                            

                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p v-else style="text-align:center;">Sin movimientos</p>
                                    </div>  

                                </div>
                                
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer" v-if="!datos.registro_cargando">
                        
                        <button type="button" class="boton-3d-success" @click=enviar_datos_movimiento>
                            Guardar nuevo movimiento
                        </button>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">
                            Cerrar
                        </button>

                    </div>
                </div>
            </div>
        </div>
        <!---fin modal registro---->

        <!-- inicio modal bancos -->
        <div class="modal fade bd-example-modal-lg" id="modal_registro_bancos">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        
                        <h5>
                            Bancos disponibles
                        </h5>

                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <button class='boton-3d-success' type="button" @click="agregar_banco('')">
                                <i class='fa fa-plus' aria-hidden='true'></i>
                                Agregar banco
                            </button>
                            <div v-for='(b,b_index) in datos.registro_bancos.todos' :key="b_index" id="contenedor-bancos" class="form-row">
                                
                                <template v-if="b.estado=='activo'">
                                    <div class="form-group col-md-11">
                                        <label for="inputEmail4">Banco:</label> 
                                        <input type="text" maxlength="80" class="form-control input-3d" v-model=b.nombre>
                                    </div>
                                    <div class="form-group col-md-1">
                                        <div style="height:100%; display:flex; align-items:end;">
                                            <button class='boton-3d-danger' type="button" @click=remover_banco(b_index)>
                                                <i class='fa fa-times' aria-hidden='true'></i>
                                            </button>
                                        </div>
                                    </div>  
                                </template>                                                          
                                
                            </div>                                                      
                        </div>
                    </div>
                    <div class="modal-footer">
                        
                        <button type="button" class="boton-3d-success" @click=enviar_datos_bancos>
                            Guardar
                        </button>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">
                            Cerrar
                        </button>

                    </div>

                </div>
            </div>
        </div>
        <!---fin modal bancos---->


    </div>

</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
//import { mapMutations } from 'vuex'

import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                id:'',
                bancos_id:'',
                cuenta:'',
                clabe_interbancaria:'',
                titular:'',
                numero_tarjeta:'',
                clave_visualizar:''
            },
            banco_nombre:'',
            registro_movimientos:{
                operacion:'',
                cantidad:'',
                fecha_creacion:'',
                descripcion:''
            },
            registro_bancos:{
                todos:[]
            },
            ultimos_movimientos:[],
            ultimo_total:'',

            data_table:{
                cargando:false,
                registros:[]
            },

            bancos:{
                todos:[]
            }
        }
    }
    },
    mounted(){
        /* let a=this.fecha_hoy;
        console.log('fecha 2 de hoy es');
        console.log(a); */

        //console.log('moneda es');
        //console.log(this.formato_moneda(5));
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        //...mapActions(['formato_moneda']),
        inicial()
        {
            if(this.general.otros.autenticado===true)
            {
                this.obtener_recursos();
                //this.data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            }
        },  
        obtener_recursos()
        {
            this.data_table();
            fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/recursos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos');
                console.log(respuesta);
                this.datos.bancos.todos=respuesta.datos.bancos;

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },    
        boton_modal_registro()
        {
            for (const p in this.datos.registro) {                    
                                
                this.datos.registro[p]='';                
                
            }                             

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
        },
        boton_modal_registro_bancos()
        {
            this.datos.registro_cargando=true;
            this.datos.registro_bancos.todos=[];                           

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal_registro_bancos").modal("show");            

            fetch(`${this.general.otros.dominio_server}/bancos/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{

                let b=respuesta.datos.bancos;
                b.forEach((item,index)=>{
                    console.log('banco');
                    console.log(item);
                    this.agregar_banco(item);
                });

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo obtener la información`});
            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });

        },
        data_table()
        {
            this.datos.data_table.cargando=true;            
            fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/todos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                
                this.datos.data_table.registros=respuesta.datos;                
                this.data_table_crear();
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse las cuentas`});
            })
            .finally( () => {
                this.datos.data_table.cargando=false;                
            });
        },
        data_table_crear()
        {
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Banco</th>
                            <th>Numero de tarjeta</th>
                            <th>Titular</th>
                            <th>Dinero disponible</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Id</th>
                            <th>Banco</th>
                            <th>Numero de tarjeta</th>
                            <th>Titular</th>
                            <th>Dinero disponible</th>
                            <th>Acciones</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
        
                $( 'input', this ).on( 'keyup change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'desc'],
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[
                    {"targets":0, "data":function(data,type,full,meta)
                        {
                            return data.id;
                        }
                    }, 
                    {"targets":1, "data":function(data,type,full,meta)
                        {                            
                            return data.banco;
                        }
                    },                    
                    {"targets":2, "data":(data,type,full,meta)=>
                        {
                            return data.numero_tarjeta;
                        }   
                    },
                    {"targets":3, "data":(data,type,full,meta)=>
                        {
                            let t=this.general_no_xss(data.titular);
                            return  t;
                        }   
                    },
                    {"targets":4, "data":(data,type,full,meta)=>
                        {
                            return this.general_formato_moneda(data.ultimo_total);
                        }   
                    },
                    {"targets":5, "data":(data,type,full,meta)=>
                        {
                            var acciones=``;                            

                            acciones+=`
                                <button registro-clave='${data.clave_visualizar}' class="boton-modal-editar-registro boton-3d-info" style="margin-right:1em;">                                    
                                    <i registro-clave='${data.clave_visualizar}' class="fa fa-pencil-square-o" aria-hidden="true"></i>                                    
                                </button>
                                <button registro-clave='${data.clave_visualizar}' class="boton_modal_movimientos boton-3d-info" style="margin-right:1em;">                                    
                                    Movimientos
                                </button>
                                <button registro-clave='${data.clave_visualizar}' registro-id='${data.id}' class="boton-modal-remover boton-3d-danger" style="margin-right:1em;">
                                    <i registro-clave='${data.clave_visualizar}' registro-id='${data.id}' class='fa fa-times' aria-hidden='true'></i>                                    
                                </button>
                            `;

                            return `
                                <div style="display:flex; justify-content:left;">
                                    ${acciones} 
                                </div>
                            `;
                        }
                    }
                ],
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                this.eventos_data_table();
            } );
            
        },
        eventos_data_table()
        {
            Array.from(document.getElementsByClassName("boton-modal-editar-registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_evento);
            });

            Array.from(document.getElementsByClassName("boton_modal_movimientos")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_movimientos);
            });

            Array.from(document.getElementsByClassName("boton-modal-remover")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_remover);
            });
            
            /* Array.from(document.getElementsByClassName("boton-modal-eliminar")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_eliminar);
            }); */
        },
        boton_modal_movimientos(item)
        {
            for (const p in this.datos.registro) {                                                    
                this.datos.registro[p]='';                               
            } 

            this.datos.banco_nombre='';
            this.datos.registro.clave_visualizar=calculos.atributo(item,'registro-clave');
            this.datos.registro_cargando=true;   

            for (const p in this.datos.registro_movimientos) {                                                    
                this.datos.registro_movimientos[p]='';                                
            }             

            this.datos.registro_movimientos.fecha_creacion=this.general_fecha_hoy;
            this.datos.ultimos_movimientos=[];
            this.datos.ultimo_total='';

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal_movimientos").modal("show");  
            document.getElementById('input_cantidad').focus();

            fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/${this.datos.registro.clave_visualizar}/movimientos/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                console.log('movimientos');
                console.log(respuesta);

                this.boton_modal_movimientos_2(respuesta);



            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo obtener la información`});
            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });

            //this.datos.registro_cargando=false;   
        },
        boton_modal_movimientos_2(respuesta)
        {
            let r=this.datos.registro;

            let c=respuesta.datos.cuenta;
            if(c.length>0)
            {         
                c=c[0];           
                //r.banco         =c.banco;
                //r.bancos_id     =c.bancos_id;
                r.cuenta        =c.cuenta;
                r.titular       =c.titular;
                this.datos.ultimo_total  =c.ultimo_total;
                this.datos.banco_nombre=c.banco;
            }

            (respuesta.datos.movimientos).forEach((m)=>{

                if(
                    m.estado=='activo' &&
                    m.origen=='cuentas_bancarias'
                    //[null,''].includes(m.ventas_transferencias_id) && 
                    //[null,''].includes(m.compras_transferencias_id) &&  
                    //[null,''].includes(m.ventas_pendientes_pagos_id)
                )
                {
                    m.mostrar_boton_remover=true;
                }
                else
                {
                    m.mostrar_boton_remover=false;
                }

            });
                                            
            this.datos.ultimos_movimientos=respuesta.datos.movimientos;
        },


        boton_modal_remover(item)
        {
            //this.datos.registro.i
            let dt={
                id:calculos.atributo(item,'registro-id'),
                clave:calculos.atributo(item,'registro-clave')
            };
            Swal.fire({
                title: `¿ Remover cuenta id : ${dt.id} ?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, remover ahora",
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) 
                {
                    this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                    fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/registro/remover`,{
                        method:'POST',
                        body:JSON.stringify( {
                            //id:dt.id,
                            clave:dt.clave
                        } ),
                        headers:{                    
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                            'Content-Type'  :'application/json',
                            'Accept'        :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',                   
                    })
                    //.then(res=>res.json())
                    .then(res => {
                        if (res.status == 200) 
                        {
                            return res.json();
                        }
                        else
                        {
                            throw new Error(`Error: ${res.status}`);
                        }
                    })
                    .then(respuesta=>{
                        let dt={
                            'bien':()=>{                        
                                this.data_table();
                                //$("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Cuenta removida`});
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }                
                    })
                    .catch(error=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`La cuenta no se pudo remover`});
                    })
                    .finally( () => {
                        //this.datos.data_table.cargando=false;
                    });
                }
            });
        },
        boton_modal_editar_registro_evento(item)
        {        
            this.boton_modal_registro();
            this.datos.registro.clave_visualizar=item.target.getAttribute('registro-clave');  
            this.datos.registro_cargando=true;        
            //fetch(`${this.general.otros.dominio}/productos/${this.datos.registro.id}/datos`)
            fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/${this.datos.registro.clave_visualizar}/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{

                if(respuesta.datos.cuenta.length>0)
                {
                    let c=respuesta.datos.cuenta[0];
                    let r=this.datos.registro;

                    r.bancos_id             =c.bancos_id;
                    r.cuenta                =c.cuenta;
                    r.clabe_interbancaria   =c.clabe_interbancaria;
                    r.titular               =c.titular;   
                    r.numero_tarjeta        =c.numero_tarjeta;
                }

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo obtener la información`});
            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
            
        },                     
        
        enviar_datos(a)
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'}); 
            fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/registro`,{
                method:'POST',                
                body:JSON.stringify(this.datos.registro),
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        this.data_table();
                        $("#modal-registro").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Cuenta guardada`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`La cuenta no se pudo guardar`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        },   
        enviar_datos_movimiento()
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'}); 
            fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/movimientos/registro`,{
                method:'POST',                
                body:JSON.stringify({
                    cuentas_bancarias_clave_visualizar:this.datos.registro.clave_visualizar,
                    movimiento          :this.datos.registro_movimientos
                }),
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        this.data_table();
                        $("#modal_movimientos").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Movimiento guardado`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`El movimiento no se pudo guardar`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        },
        remover_movimiento(clave_visualizar)        
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'}); 
            fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/movimientos/registro/remover`,{
                method:'POST',                
                body:JSON.stringify({
                    cuentas_bancarias_movimientos_clave_visualizar:clave_visualizar                 
                }),
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        this.data_table();
                        //$("#modal_movimientos").modal("hide");
                        this.boton_modal_movimientos_2(respuesta);
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Movimiento revertido`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`El movimiento no se pudo remover`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        },

        agregar_banco(b)
        {
            this.datos.registro_bancos.todos.push({
                id      :b==='' ? '' : b.id,
                nombre  :b==='' ? '' : b.nombre,
                estado  :'activo',
                posicion:''
            });
        },
        remover_banco(index)
        {
            this.datos.registro_bancos.todos[index].estado='inactivo';
        },
        enviar_datos_bancos(a)
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'}); 
            
            let b=this.datos.registro_bancos.todos.filter((e)=>e.estado=='activo' || (e.estado=='inactivo' && e.id!=='') )

            fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/bancos/registro`,{
                method:'POST',
                body:JSON.stringify({
                    bancos:b
                }),
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        //this.data_table();
                        this.obtener_recursos();
                        $("#modal_registro_bancos").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Bancos guardados`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo guardar`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });

        },
        operacion_seleccionado()
        {
            document.getElementById('input_cantidad').focus();
        },
        cantidad_ingresado($event)
        {
            if($event.key=='Enter')
            {
                document.getElementById('input_descripcion').focus();
            }
        }
    },
    computed: {
        ...mapState(['general']),
        ...mapGetters([
            'general_fecha_hoy',
            'general_no_xss',
            'general_formato_moneda'
        ]),
        /*formato_moneda(m)
        {
            this.formatear_moneda(m);
        } */
    },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>        
    .contenedor-producto{
        background:linear-gradient(90deg, #0093ff, #484848);
        border-radius:7px; 
        margin-bottom:1em; 
        padding:1em;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
        padding-bottom:0px; 
        padding-top:0.5em;

        /* &:hover{
            background:linear-gradient(90deg, #01253f, #1d1c1c);
        } */

        label {
            color:white;
        }
    }
    #modal_movimientos{
        #contenedor_img_bancos{
            height:100%;
            display:flex;
            align-items:center;
            img{
                width:150px;
            }
        }
        #contenedor_tabla_ultimos_movimientos{
            height:300px; 
            overflow:scroll;

            .fecha_creacion{
                font-size:0.8em;
                font-weight:bold;
                margin:0px;
            }
            .hora_creacion{
                font-size:0.8em;
                font-weight:bold;
            }
            .descripcion{
                font-size:1em;
                margin:0px;
            }
            .contenedor-cantidad-remover{
                display:flex;
                flex-wrap:wrap;
                justify-content:right;
                height:100px;
                align-content:space-between;
                .cantidad{
                    font-size:1.5em;
                    width:100%;
                    text-align:right;
                }
            }
            .cantidad_restar{
                color:red;
            }
            
        }
    }
    
</style>